import {useTranslation} from 'react-i18next';
import React, {useState} from 'react';
import Grid from '@mui/material/Grid';
import {FormLabel, Stack} from '@mui/material';
import EscortList from './escortList';
import AgyleButton from '../../../components/ui/buttons/agyleButton';
import AgyleTextField from '../../../components/ui/fields/agyleTextField';
import AgyleBlockSwitch from '../../../components/ui/switch/agyleBlockSwitch';
import InformationBox from '../../../components/other/informationBoxNew';

const initEscort = {
  name: "",
  phone: "",
  relationship: "",
  parentalResponsibility: false,
  attendedWithChild: false,
  contact: "",
};

export default function EscortSection({ admission, setAdmission, isSmall }) {
  const { t } = useTranslation();

  const [escortForm, setEscortForm] = useState(initEscort);

  const handleChangeEscort = (e) => {
    const { name, value } = e.target;

    setEscortForm((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleAddEscort = () => {
    let escortArr;

    if (admission.escortArray.length === 0) {
      escortArr = [escortForm];
    } else {
      escortArr = [...admission.escortArray, escortForm];
    }
    setAdmission((prevState) => ({
      ...prevState,
      escortArray: escortArr,
    }));
    setEscortForm(initEscort);
  };

  const handleRemoveEscort = (index) => {
    const newEscortArray = admission.escortArray.filter(
      (escort, i) => i !== index,
    );

    setAdmission((prevState) => ({
      ...prevState,
      escortArray: newEscortArray,
    }));
  };

  return (
      <Grid
        container
        spacing={2}
        sx={{ m: 1, pr: 3, pl: 0 }}
        alignItems="center"
      >
        <InformationBox type="info">
          {t(
            "Please add who does have parental/legal responsibility for the patient and what are their contact details, and who attended with a child",
          )}
        </InformationBox>

        <Grid item xs={12} sx={{ mt: 2, pl: 0 }}>
          <Stack
            direction={isSmall ? 'column' : 'row'}
            alignItems={isSmall ? 'flex-start' : 'center'}
            justifyContent="space-between"
          >
            <Stack
                direction={isSmall ? 'column' : 'row'}
                alignItems={isSmall ? 'flex-start' : 'center'}
                spacing={1}
                sx={{mb: isSmall ? 1 : 0}}
            >
              <FormLabel sx={{ mr: 2 }}>
                {t("Parental Responsibility")}
              </FormLabel>

              <Grid item sx={{ mr: 3 }}>
                <AgyleBlockSwitch
                  onChange={() =>
                    setEscortForm((prevValue) => ({
                      ...prevValue,
                      parentalResponsibility: !prevValue.parentalResponsibility,
                    }))
                  }
                  value={escortForm.parentalResponsibility || false}
                  style={{ marginRight: 10 }}
                />
              </Grid>

              <FormLabel>{t("Attended with a child")}</FormLabel>

              <Grid item sx={{ ml: isSmall ? 0 : 2 }}>
                <AgyleBlockSwitch
                  onChange={(val) =>
                    setEscortForm((prevValue) => ({
                      ...prevValue,
                      attendedWithChild: !prevValue.attendedWithChild,
                    }))
                  }
                  value={escortForm.attendedWithChild || false}
                  style={{ marginRight: 10 }}
                />
              </Grid>
            </Stack>

            <AgyleButton
              onClick={handleAddEscort}
              variant="contained"
              size="large"
            >
              {t("ADD NEW ESCORT")}
            </AgyleButton>
          </Stack>
        </Grid>

        <Grid item xs={12} sm={isSmall ? 12 : 3}>
          <FormLabel>{t('Name')}</FormLabel>

          <AgyleTextField
            size={"large"}
            fullWidth
            multiline
            noBorder={false}
            variant="outlined"
            placeholder={t('Name')}
            value={escortForm?.name || ""}
            name="name"
            onChange={handleChangeEscort}
          />
        </Grid>

        <Grid item xs={12} sm={isSmall ? 12 : 2}>
          <FormLabel>{t('Age')}</FormLabel>

          <AgyleTextField
            size={"large"}
            fullWidth
            multiline
            noBorder={false}
            variant="outlined"
            placeholder={t('Age')}
            type="text"
            inputProps={{
              maxLength: 3,
              inputMode: "numeric",
              pattern: "/^-?d+(?:.d+)?$/g",
            }}
            name="age"
            value={escortForm?.age || ""}
            onChange={(e) => {
              e.stopPropagation();
              e.preventDefault();
              e.currentTarget.value = e.target.value.replace(/[\D\s]/, "");
              handleChangeEscort(e);
            }}
          />
        </Grid>

        <Grid item xs={12} sm={isSmall ? 12 : 3}>
          <FormLabel>{t('Relationship')}</FormLabel>

          <AgyleTextField
            size={"large"}
            fullWidth
            multiline
            noBorder={false}
            variant="outlined"
            placeholder={t('Relationship')}
            name="relationship"
            value={escortForm?.relationship || ""}
            onChange={handleChangeEscort}
          />
        </Grid>

        <Grid item xs={12} sm={isSmall ? 12 : 4}>
          <FormLabel>{t('Contact Details')}</FormLabel>

          <AgyleTextField
            size={"large"}
            multiline
            noBorder={false}
            variant="outlined"
            placeholder={t('Contact Details')}
            fullWidth
            name="contact"
            value={escortForm?.contact || ""}
            onChange={handleChangeEscort}
          />
        </Grid>

        <Grid item xs={12}>
          <EscortList admit={admission} deleteItem={handleRemoveEscort} />
        </Grid>
      </Grid>
  );
}
